import { render, staticRenderFns } from "./verificationCodeButton.vue?vue&type=template&id=0e4e1644&scoped=true&"
import script from "./verificationCodeButton.vue?vue&type=script&lang=js&"
export * from "./verificationCodeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4e1644",
  null
  
)

export default component.exports